import { ILandingPage } from '../../../types/@types/generated/contentful';
import { getByUniqueSlug } from '../../../utils/api/contentful';
import { UrlError } from '../../../utils/error';
import { getServerSideProps, getTemplatePage, TemplatePageProps } from '../util/template';

export type Props = TemplatePageProps;

export const createTemplatePage = ({ campaignName }: { campaignName?: string } = {}) => {
  return getTemplatePage({ campaignName });
};

export const createGetServerSideProps = (slug: string, tags?: string[], locale?: string) => {
  return async (): Promise<{ props: Props }> => {
    const page = await getByUniqueSlug<ILandingPage>({
      contentType: 'landingPage',
      slug,
      tags,
      include: 4,
      locale,
    });

    if (!page) {
      const error = new UrlError(`${slug} with tags ${tags} in contentful not found`, {
        status: 404,
      });

      throw error;
    }

    return await getServerSideProps({ page });
  };
};
